
<list-item
  :card="item"
  :fields="['date', 'listingType', 'price']"
  v-bind="$attrs"
  v-on="$listeners"
>
  <template #image>
    <card-image :image-url="item.thumbnail || item.image" />
  </template>

  <template #info>
    <div class="sales-list-item-info">
      <div class="platform-text">
        <span>{{ item.platform }}</span><span v-if="item.seller"> - {{ item.seller }}</span>
      </div>
      <div class="item-text">{{ item.title }}</div>
      <div class="actions" v-if="$slots.default">
        <slot />
      </div>
    </div>
  </template>

</list-item>
